<form (ngSubmit)="onSubmit()" class="email-modal" ngNativeValidate>
  <div class="email-header">
    <h3 class="modal-title email-title" id="modal-title">{{ 'EMAIL_MODAL.SEND_EMAIL' | translate }}</h3>
    <img class="pointer" width="24" height="24" [alt]="'EMAIL_MODAL.DOWNLOAD' | translate" src="assets/img/close.svg" (click)="cancel()">
  </div>
  <div class="modal-body" id="modal-body">
    <div class="">
      <div class="mg-15">
        <label for="emailName">{{ 'EMAIL_MODAL.NAME' | translate }}</label>
        <input type="text" required name="emailName" [(ngModel)]="email.name" id="emailName" class="form-control" 
          title="{{ 'EMAIL_MODAL.EMAIL_NAME' | translate }}" placeholder="{{ 'EMAIL_MODAL.EMAIL_NAME' | translate }}">
      </div>
      <div class="mg-15">
        <label for="emailAddress">{{ 'EMAIL_MODAL.EMAIL' | translate }}</label>
        <input type="text" required name="emailAddress" [(ngModel)]="email.from" id="emailAddress" class="form-control" 
          title="{{ 'EMAIL_MODAL.EMAIL_ADDRESS' | translate }}" placeholder="{{ 'EMAIL_MODAL.EMAIL_ADDRESS' | translate }}">
      </div>
      <div class="mg-15">
        <label for="subject">{{ 'EMAIL_MODAL.SUBJECT' | translate }}</label>
        <input type="text" required name="subject" [(ngModel)]="email.subject" id="subject" class="form-control" 
          title="{{ 'EMAIL_MODAL.SUBJECT' | translate }}" placeholder="{{ 'EMAIL_MODAL.SUBJECT' | translate }}">
      </div>
      <div class="mg-15">
        <div class="NgxEditor__Wrapper">
          <ngx-editor-menu [editor]="editorConfig" [toolbar]="toolbar"> </ngx-editor-menu>
          <ngx-editor resizer="none" [editor]="editorConfig" [(ngModel)]="email.text" name="editorText" [disabled]="false" [placeholder]="'EMAIL_MODAL.MESSAGE' | translate"></ngx-editor>
        </div>
      </div>
      <div class="errorMessage mg-10" *ngIf="errorMessage">
        {{ 'EMAIL_MODAL.' + errorMessage | translate }} 
      </div>
    </div>
  </div>
  <div class="captcha-container" *ngIf="activateCaptcha">
    <form [formGroup]="aFormGroup" class="captcha-block">
      <re-captcha formControlName="recaptcha" (resolved)="onCaptchaResolved($event)"></re-captcha>
    </form>
  </div>
  <div class="email-footer text-center">
    <button class="btn btn--submit" [style.background-color]="catalogueService.getProperty('mainColor')" [style.color]="catalogueService.getProperty('languageColor')" type="submit" [disabled]="!captchaOK || !exhibitorEmail">
      {{ 'EMAIL_MODAL.SEND' | translate }}
    </button>
  </div>
</form>
